import { styled } from "styled-components";

const Container = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem 1.5rem;
  flex-grow: 1;
  z-index: 10;
  > button {
    max-width: 115px;
    & > svg {
      flex-shrink: 0;
      transform: rotate(225deg);
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    margin-bottom: 0.825rem;
  }
  margin-bottom: 4.5rem;
`;

const Title = styled.p`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-size: 2rem;
  font-style: normal;
  font-weight: 900;
  line-height: 100%; /* 28px */
  margin-bottom: 2rem;
`;

const CardContainer = styled.div`
  border-radius: 1.5rem;
  border: 1px solid #2c3034;
  background: #f5e8ed;
  box-shadow: 4px 4px 0px 0px #2c3034;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  margin-bottom: 1.5rem;

  > img:first-of-type {
    width: 2.25rem;
    height: 2.25rem;
    margin-bottom: 0.75rem;
  }
  > img:last-of-type {
    width: 100%;
    height: 100%;
  }
`;

const CardTitle = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 25.2px */
  margin: 0.5rem 0;
`;

const CardDescription = styled.p`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
`;

const CardNumber = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  text-shadow: 1px 1px 0px ${({ theme }) => theme.colors.black};
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-size: 2rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
`;

const ButtonContainer = styled.div`
  position: fixed;
  bottom: 1.5rem;
  display: flex;
  width: 100%;
  > button {
    margin: 0 33px;
    width: 100%;
  }
`;

export default {
  Container,
  MainContainer,
  Title,
  CardContainer,
  CardTitle,
  CardDescription,
  CardNumber,
  ButtonContainer,
};
